<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">Select your preference</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">×</button>
      </div>
      <div class="modal-body">
        <!-- <h3>Select your preference</h3> -->
        <div class="row select-row">
          <div class="col-xs-6 col-sm-6 select-left-col">
            <button (click)="setPreference('Individual', 'Individual')" class="preference-button"
              [ngClass]="{'active': preference == 'Individual' }" data-plangroup="Individual"> Individual </button>
          </div>
          <div class="col-xs-6 col-sm-6 select-right-col">
            <button (click)="setPreference('Individual + Spouse', 'IndividualSpouse')" class="preference-button"
              [ngClass]="{'active': preference == 'Individual + Spouse' }" data-plangroup="IndividualSpouse"> Individual
              + Spouse </button>
          </div>
        </div>
        <div class="row select-row">
          <div class="col-xs-6 col-sm-6 select-left-col">
            <button (click)="setPreference('Individual + Family', 'IndividualFamily')" class="preference-button"
              [ngClass]="{'active': preference == 'Individual + Family' }" data-plangroup="IndividualFamily"> Individual
              + Family </button>
          </div>
          <div class="col-xs-6 col-sm-6 select-right-col">
            <button (click)="setPreference('Individual + Children', 'IndividualChildren')" class="preference-button"
              [ngClass]="{'active': preference == 'Individual + Children' }" data-plangroup="IndividualChildren">
              Individual + Children </button>
          </div>
        </div>

        <div class="child-no">
          @if(preference == 'Individual + Family' || preference == 'Individual + Children') {

          <h3>No. of Children</h3>
          <div class="num-options">
            <div (click)="decreaseCount()" class="digits cp">-</div>
            <input type="text" name="children" [(ngModel)]="noOfChildren" id="noOfChild" class="children-input"
              value="0" readonly="">
            <div (click)="increaseCount()" class="digits cp">
              +
            </div>
            <span class="max-info">( Max 8 ) </span>
          </div>
          <div *ngIf="childErr" class="child-error" style="color: red;">Please enter number of children(s)</div>
          }
        </div>

      </div>
      <div class="modal-btns">
        <div class="row btn-row">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
             <button type="button" class="btn modalButton orange-border"
              data-bs-dismiss="modal">Cancel</button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"> 
            <button (click)="saveAndClose()" type="button"
              class="btn modalButton">Save & Close</button>
          </div>

        </div>



      </div>
    </div>
  </div>
</div>